module.exports = __webpack_public_path__ + "static/join-team-96525a8857e255fee4b0a7e44d552606.jpg";